import {GET_CANDIDATE_ASSESSMENT_STATUS, GET_CANDIDATE_ASSESSMENT_STATUS_SUCCESS, GET_CANDIDATE_ASSESSMENT_STATUS_ERROR, GET_CANDIDATE_ASSESSMENT_OVERRIDE, GET_CANDIDATE_ASSESSMENT_OVERRIDE_SUCCESS, GET_CANDIDATE_ASSESSMENT_OVERRIDE_ERROR} from './actionTypes'

export const getCandidateAssessmentStatus = (data) => {
    return {
      type: GET_CANDIDATE_ASSESSMENT_STATUS,
      payload: {data },
    }
  }

  export const getCandidateAssessmentStatusSuccess = (data) => {
    return {
      type: GET_CANDIDATE_ASSESSMENT_STATUS_SUCCESS,
      payload: {data},
    }
  }

  export const getCandidateAssessmentStatusError = (error) => {
    return {
      type: GET_CANDIDATE_ASSESSMENT_STATUS_ERROR,
      payload: {error},
    }
  }

  export const overRideCandidateAssessment = (data) => {
    return {
      type: GET_CANDIDATE_ASSESSMENT_OVERRIDE,
      payload: {data },
    }
  }

  export const overRideCandidateAssessmentSuccess = (data) => {
    return {
      type: GET_CANDIDATE_ASSESSMENT_OVERRIDE_SUCCESS,
      payload:data,
    }
  }

  export const overRideCandidateAssessmentError = (data) => {
    return {
      type: GET_CANDIDATE_ASSESSMENT_OVERRIDE_ERROR,
      payload:data,
    }
  }
